import ReactPixel from 'react-facebook-pixel';

const FACEBOOK_PIXEL_ID = '1055051599574751'; // My Facebook Pixel ID

const options = {
    autoConfig: true,
    debug: false
};

export const initFacebookPixel = () => {
    if (!FACEBOOK_PIXEL_ID) return;

    ReactPixel.init(FACEBOOK_PIXEL_ID, undefined, options);
};

export const trackPageView = () => {
    if (!FACEBOOK_PIXEL_ID) return;
    ReactPixel.pageView();
};

export const trackEvent = (event: string, data = {}) => {
    if (!FACEBOOK_PIXEL_ID) return;
    ReactPixel.track(event, data);
};

export const trackCustom = (event: string, data = {}) => {
    if (!FACEBOOK_PIXEL_ID) return;
    ReactPixel.trackCustom(event, data);
};

// Standard Facebook events
export const Events = {
    CONTACT_FORM_SUBMIT: 'Contact',
    COMPLETE_REGISTRATION: 'CompleteRegistration',
    LEAD: 'Lead',
    VIEW_CONTENT: 'ViewContent',
    SCROLL: 'Scroll',
    SEARCH: 'Search',
    ADD_TO_CART: 'AddToCart',
    INITIATE_CHECKOUT: 'InitiateCheckout',
    ADD_PAYMENT_INFO: 'AddPaymentInfo',
    PURCHASE: 'Purchase'
}; 